import { HardwareStatus } from '../../domainServices/HardwareService';
import { fetchWrapper } from '../fetchWrapper';

export async function unassignHardwareFromOffice(
  id: string,
  hardwareIds: Record<number, HardwareStatus>,
) {
  return fetchWrapper({
    url: `api/office/${id}/hardware/unassignment`,
    fetchArg: {
      method: 'PUT',
      headers: {
        accept: 'text/plain',
        'Content-Type': 'application/json-patch+json',
      },
      body: { hardwareIds },
    },
  });
}
